import { TextAreaProps } from 'spindl-shared-components';


type ModalTextContentInternalProps = {
  textArea?: TextAreaProps;
};

type ModalTextContentPropsValues = {
  'Default': ModalTextContentInternalProps;
  'Error': ModalTextContentInternalProps;
  'Expanded': ModalTextContentInternalProps;
  'FirstSelect': ModalTextContentInternalProps;
  'FirstSelectExpanded': ModalTextContentInternalProps;
};

const propValues: ModalTextContentPropsValues = {
  'Default': {
    textArea: {
      styleType: 'Dark',
      size: 'Small',
    },
  },
  'Error': {
    textArea: {
      styleType: 'Dark',
      size: 'Small',
    },
  },
  'Expanded': {
    textArea: {
      styleType: 'Dark',
      size: 'Small',
    },
  },
  'FirstSelect': {
    textArea: {
      styleType: 'Dark',
      size: 'Small',
    },
  },
  'FirstSelectExpanded': {
    textArea: {
      styleType: 'Dark',
      size: 'Small',
    },
  },
};

const getProps = (type: string): ModalTextContentInternalProps => {
  const values: ModalTextContentInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
